import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { ArrecadacaoAutomaticaPeriodoDemonstrativoEnum } from "core/features/arrecadacoes/enums";

export interface SelectPeriodoDemonstrativoProcessarArrecadacaoProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectPeriodoDemonstrativoProcessarArrecadacao({
  value,
  onChange,
  ...rest
}: SelectPeriodoDemonstrativoProcessarArrecadacaoProps) {
  return (
    <SelectBaseAntd
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      getPopupContainer={(node) => node.parentNode}
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={[
        {
          label: "Mês anterior até a data de vencimento",
          value:
            ArrecadacaoAutomaticaPeriodoDemonstrativoEnum.MesAnteriorAteVencimento,
        },
        {
          label: "Mês anterior até a data de processamento",
          value:
            ArrecadacaoAutomaticaPeriodoDemonstrativoEnum.MesAnteriorAteProcessamento,
        },
        {
          label: "Mês atual até a data de vencimento",
          value:
            ArrecadacaoAutomaticaPeriodoDemonstrativoEnum.MesAtualAteVencimento,
        },
        {
          label: "Mês atual até a data de processamento",
          value:
            ArrecadacaoAutomaticaPeriodoDemonstrativoEnum.MesAtualAteProcessamento,
        },
      ]}
      {...rest}
    />
  );
}

export default SelectPeriodoDemonstrativoProcessarArrecadacao;
